import { usePageMenuPainter } from "@/ui/hooks/usePageMenuPainter"
import { ThemeColor } from "@punks/ui-core"
import { useRef } from "react"

export interface BlokWrapperProps {
  contents: any
  children: any
  style?: React.CSSProperties
  className?: string
  menuColor?: ThemeColor
}

const BlokWrapper = ({
  contents,
  children,
  style,
  className,
  menuColor,
}: BlokWrapperProps) => {
  const ref = useRef(null)
  usePageMenuPainter(ref, menuColor)

  return (
    <div
      id={contents.anchorId}
      style={style}
      className={className}
      data-content-type={contents._type}
      ref={ref}
    >
      {children}
    </div>
  )
}

export default BlokWrapper
